const ButtonLoader = () => {
  return (
    <span
      className='spinner-border spinner-border-sm btn-spinner float-end mt-1'
      role='status'
      aria-hidden='true'
    ></span>
  );
};

export default ButtonLoader;
